var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0837 14.5833H9.88592L8.04297 33.75H31.9577L30.1148 14.5833H27.917V20C27.917 20.6903 27.3574 21.25 26.667 21.25C25.9767 21.25 25.417 20.6903 25.417 20V14.5833L14.5837 14.5833V20C14.5837 20.6903 14.024 21.25 13.3337 21.25C12.6433 21.25 12.0837 20.6903 12.0837 20V14.5833ZM14.6191 12.0833L25.3815 12.0833C25.094 9.73513 23.0929 7.91663 20.667 7.91663H19.3337C16.9078 7.91663 14.9067 9.73513 14.6191 12.0833ZM27.8939 12.0833H30.3419C31.5011 12.0833 32.4706 12.964 32.5816 14.1179L34.4726 33.7846C34.5997 35.1062 33.5607 36.25 32.2329 36.25L7.76778 36.25C6.44005 36.25 5.40103 35.1062 5.52811 33.7846L7.41914 14.1179C7.53009 12.964 8.49959 12.0833 9.65881 12.0833H12.1068C12.4039 8.35199 15.526 5.41663 19.3337 5.41663H20.667C24.4747 5.41663 27.5968 8.352 27.8939 12.0833Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingEmpty);
export default __webpack_public_path__ + "static/media/shopping-empty.0a0d1e96.svg";
export { ForwardRef as ReactComponent };